const en = {
  dailyFrequencyTitle: 'Daily service frequency',
  dailyFrequencyDescription:
    'One row per provider and Bangkok service day, only where Trips exist. Requests are service-date Trips, not bookings created that day. Accepted/completed milestones can overlap current cancelled/missed states. Area filters use CURRENT_SERVICE_GROUP mappings. Customer finance is persisted billing, not agent payout or reconstructed notional fare.',
  dailyFrequencyDateBasis: 'Service date · Asia/Bangkok · scheduled start, otherwise Trip creation',
  dailyFrequencyValue_serviceDate: 'Service-date cohort',
  dailyFrequencyFilter_serviceMode: 'Service mode',
  dailyFrequencyFilter_isFree: 'Free booking',
  dailyFrequencyMode_RIDE_AND_CARE: 'Ride and care',
  dailyFrequencyMode_CARE: 'Care',
  dailyFrequencyMode_RIDE: 'Ride',
  dailyFrequencyMode_TRAVEL: 'Travel',
  dailyFrequencyColumn_provider_id: 'Provider ID',
  dailyFrequencyColumn_provider_name: 'Provider name (current)',
  dailyFrequencyColumn_business_date: 'Service business date (Bangkok)',
  dailyFrequencyColumn_date_basis: 'Date basis',
  dailyFrequencyColumn_scheduled_date_trip_count: 'Trips using scheduled start',
  dailyFrequencyColumn_created_date_fallback_trip_count: 'Trips using creation-date fallback',
  dailyFrequencyColumn_requests_count: 'Service-date Trips',
  dailyFrequencyColumn_accepted_trip_count: 'Trips with acceptance evidence',
  dailyFrequencyColumn_completed_trip_count: 'Trips with completion evidence',
  dailyFrequencyColumn_cancelled_trip_count: 'Currently cancelled Trips',
  dailyFrequencyColumn_missed_trip_count: 'Currently missed Trips',
  dailyFrequencyColumn_cancelled_by_passenger_count: 'Cancelled by passenger',
  dailyFrequencyColumn_cancelled_by_agent_count: 'Cancelled by agent',
  dailyFrequencyColumn_cancelled_by_org_user_count: 'Cancelled by organization user',
  dailyFrequencyColumn_cancelled_by_system_count: 'Cancelled by system',
  dailyFrequencyColumn_cancelled_by_other_count: 'Cancelled by other recorded actor (partner)',
  dailyFrequencyColumn_cancelled_by_unknown_count: 'Cancelled with unknown actor',
  dailyFrequencyColumn_offers_count: 'Offers linked to service-date Trips',
  dailyFrequencyColumn_accepted_offer_count: 'Accepted offers',
  dailyFrequencyColumn_rejected_offer_count: 'Rejected offers',
  dailyFrequencyColumn_expired_offer_count: 'Expired offers',
  dailyFrequencyColumn_superseded_offer_count: 'Superseded offers',
  dailyFrequencyColumn_cancelled_offer_count: 'Cancelled offers',
  dailyFrequencyColumn_pending_offer_count: 'Pending offers',
  dailyFrequencyColumn_currency: 'Currency',
  dailyFrequencyColumn_fare_total_sum: 'Persisted fare total (THB)',
  dailyFrequencyColumn_billed_total_sum: 'Billed total (THB)',
  dailyFrequencyColumn_received_total_sum: 'Recorded receipts (THB)',
  dailyFrequencyColumn_outstanding_total_sum: 'Outstanding total (THB)',
  dailyFrequencyColumn_free_trip_count: 'Trips in FREE payment state',
  dailyFrequencyColumn_finance_review_count: 'Trips requiring finance review',
  dailyFrequencyColumn_missing_fare_count: 'Trips without persisted fare total',
  dailyFrequencySummary_totalRows: 'Provider-day rows',
  dailyFrequencySummary_tripCount: 'Distinct service-date Trips',
  dailyFrequencySummary_scheduledDateTripCount: 'Trips using scheduled start',
  dailyFrequencySummary_createdDateFallbackTripCount: 'Trips using creation-date fallback',
  dailyFrequencySummary_acceptedTripCount: 'Trips with acceptance evidence',
  dailyFrequencySummary_completedTripCount: 'Trips with completion evidence',
  dailyFrequencySummary_cancelledTripCount: 'Currently cancelled Trips',
  dailyFrequencySummary_missedTripCount: 'Currently missed Trips',
  dailyFrequencySummary_cancelledByPassengerCount: 'Cancelled by passenger',
  dailyFrequencySummary_cancelledByAgentCount: 'Cancelled by agent',
  dailyFrequencySummary_cancelledByOrgUserCount: 'Cancelled by organization user',
  dailyFrequencySummary_cancelledBySystemCount: 'Cancelled by system',
  dailyFrequencySummary_cancelledByOtherCount: 'Cancelled by other recorded actor (partner)',
  dailyFrequencySummary_cancelledByUnknownCount: 'Cancelled with unknown actor',
  dailyFrequencySummary_offersCount: 'Offers linked to service-date Trips',
  dailyFrequencySummary_acceptedOfferCount: 'Accepted offers',
  dailyFrequencySummary_rejectedOfferCount: 'Rejected offers',
  dailyFrequencySummary_expiredOfferCount: 'Expired offers',
  dailyFrequencySummary_supersededOfferCount: 'Superseded offers',
  dailyFrequencySummary_cancelledOfferCount: 'Cancelled offers',
  dailyFrequencySummary_pendingOfferCount: 'Pending offers',
  dailyFrequencySummary_fareTotalSum: 'Persisted fare total (THB)',
  dailyFrequencySummary_billedTotalSum: 'Billed total (THB)',
  dailyFrequencySummary_receivedTotalSum: 'Recorded receipts (THB)',
  dailyFrequencySummary_outstandingTotalSum: 'Outstanding total (THB)',
  dailyFrequencySummary_freeTripCount: 'Trips in FREE payment state',
  dailyFrequencySummary_financeReviewCount: 'Trips requiring finance review',
  dailyFrequencySummary_missingFareCount: 'Trips without persisted fare total',
  dailyFrequencySummary_withoutAcceptanceEvidenceTripCount:
    'Trips without acceptance evidence (includes not yet assigned)',
  dailyFrequencySummary_completedStateWithoutEventTripCount: 'Completed state without completion event',
  dailyFrequencySummary_cancelledStateWithoutEventTripCount: 'Cancelled state without cancellation event',
  dailyFrequencySource_provider: 'Current Provider master; provider remains part of every row key.',
  dailyFrequencySource_serviceDate:
    'Trip scheduledStart, otherwise createdAt, grouped by calendar date in Asia/Bangkok. Range is [from, to); no rows are generated for zero-Trip days.',
  dailyFrequencySource_scheduled: 'Distinct cohort Trips with a persisted scheduledStart.',
  dailyFrequencySource_fallback:
    'Distinct cohort Trips without scheduledStart; service date is Trip createdAt.',
  dailyFrequencySource_cohort:
    'Distinct Trips in the service-date cohort after provider, current service-area/group, service-mode and free-booking filters. A booking with two Trips counts twice.',
  dailyFrequencySource_accepted:
    'Distinct cohort Trips with an ACCEPTED persisted offer or a TRIP ASSIGNED/REASSIGNED status event. Current Trip status alone is not evidence of acceptance.',
  dailyFrequencySource_completed:
    'Distinct cohort Trips with a persisted TRIP COMPLETED status event, regardless of event day. Current completed state alone does not count as a milestone.',
  dailyFrequencySource_terminal:
    'Current persisted Trip CANCELLED/MISSED state at the repeatable-read snapshot; these may overlap accepted/completed milestones.',
  dailyFrequencySource_cancellation:
    'Latest TRIP CANCELLED event by event timestamp then event ID for a currently cancelled Trip. No inference from booking creator or current assignee.',
  dailyFrequencySource_cancellationOther:
    'Latest cancellation event with the canonical PARTNER actor. Noncanonical actor types are unknown, never organization users.',
  dailyFrequencySource_cancellationUnknown:
    'Latest cancellation event has no actor or a noncanonical actor type, or no cancellation event exists. All actor buckets together equal cancelled Trips.',
  dailyFrequencySource_offers:
    'Distinct persisted offer IDs linked to cohort Trips, split by current offer status. The cohort service day is used, not offeredAt or notification attempts.',
  dailyFrequencySource_finance:
    'Canonical one-row-per-Trip persisted BASE/OVERAGE customer finance. Cancelled/missed billed and outstanding are zero. Offers, areas and verification events cannot multiply money; no new repricing or rounding.',
  dailyFrequencySource_fare:
    'Sum of non-null persisted fare.total from canonical Trip finance. Missing totals are excluded and counted separately; no reconstructed notional fare.',
  dailyFrequencySource_receipts:
    'Canonical persisted payment amountReceived, including terminal Trips and fully refunded receipts. This is not net cash after refunds.',
  dailyFrequencySource_free:
    'Count of canonical payment_state=FREE, not every booking whose isFree flag is true. Missing fare with payments may require review instead.',
  dailyFrequencySource_review:
    'Canonical requiresFinanceReview: includes missing fare with payment rows and terminal unrefunded receipts; fully refunded receipts with fare do not trigger terminal review.',
  dailyFrequencySource_missingFare:
    'Count of cohort Trips whose canonical persisted current fare total is unavailable.',
  dailyFrequencyMeaning_serviceDate:
    'All metrics belong to the service-date cohort, even when assignment, completion or offer events occurred on another date.',
  dailyFrequencyMeaning_scheduled:
    'Scheduled-date and creation-fallback counts partition the service-date Trip population.',
  dailyFrequencyMeaning_fallback:
    'Creation time is used only when scheduledStart is absent; it is not a booking-request event-day metric.',
  dailyFrequencyMeaning_cohort:
    'Counts service Trips, not bookings, passengers or dispatch attempts. Current area mappings only restrict the cohort and do not create extra rows.',
  dailyFrequencyMeaning_accepted:
    'A persisted acceptance milestone, not a current-status bucket; accepted then cancelled contributes to both counts.',
  dailyFrequencyMeaning_completed:
    'A persisted completion milestone, not an inferred completion from current status. Missing event evidence is reported separately.',
  dailyFrequencyMeaning_terminal:
    'Current terminal state at dataAsOf, not the number of terminal events occurring on this business date.',
  dailyFrequencyMeaning_cancellation:
    'Each currently cancelled Trip belongs to exactly one bucket using its latest cancellation event actor.',
  dailyFrequencyMeaning_cancellationOther:
    'Other means a canonical recorded PARTNER actor, not a guessed operator or arbitrary unrecognized actor type.',
  dailyFrequencyMeaning_cancellationUnknown:
    'Unknown is honest missing/noncanonical actor evidence; it is not reassigned to organization users.',
  dailyFrequencyMeaning_offers:
    'Counts offer IDs in the same Trip cohort. Accepted-offer counts and accepted-Trip counts measure different populations; no rate is implied.',
  dailyFrequencyMeaning_finance:
    'Customer billing and debt, never agent payout; terminal billed/debt are zero and no new price or rounding is applied.',
  dailyFrequencyMeaning_fare:
    'Persisted current fare only; missing values do not become a reconstructed notional fare.',
  dailyFrequencyMeaning_receipts:
    'Recorded receipts remain included for refunded and terminal payments; not net cash.',
  dailyFrequencyMeaning_free: 'Canonical FREE payment state is distinct from the free-booking filter.',
  dailyFrequencyMeaning_review:
    'A finance reconciliation flag, not an assertion that every terminal or refunded Trip is unsettled.',
  dailyFrequencyMeaning_missingFare:
    'Missing persisted current fare total explains incomplete fare sums; it is not a zero-fare Trip.',
  dailyFrequencyEmpty_zero:
    '0 means the filtered cohort has no matching count or summed amount; it is not unknown history.',
  dailyFrequencyEmpty_present: 'Always present for each sparse provider-day row.',
  dailyFrequencyEmpty_missingFare:
    '0 can mean no fare amount or only missing fare totals; read missing-fare count alongside the sum.',
} as const;

const th: Record<keyof typeof en, string> = {
  dailyFrequencyTitle: 'ความถี่การให้บริการรายวัน',
  dailyFrequencyDescription:
    'หนึ่งแถวต่อผู้ให้บริการและวันบริการตามเวลาไทย เฉพาะวันที่มีงาน จำนวนคำขอคือ Trip ในวันบริการ ไม่ใช่การจองที่สร้างวันนั้น หลักฐานการรับงาน/จบงานอาจซ้อนกับสถานะยกเลิก/พลาดปัจจุบัน ตัวกรองพื้นที่ใช้การผูกกลุ่มบริการปัจจุบัน CURRENT_SERVICE_GROUP ยอดเงินคือยอดเรียกเก็บลูกค้าที่บันทึกไว้ ไม่ใช่ค่าตอบแทนพนักงานหรือราคาเต็มที่คำนวณย้อนหลัง',
  dailyFrequencyDateBasis: 'วันบริการ · Asia/Bangkok · เวลาเริ่มตามแผน หรือเวลาสร้างงาน',
  dailyFrequencyValue_serviceDate: 'กลุ่มงานตามวันบริการ',
  dailyFrequencyFilter_serviceMode: 'รูปแบบบริการ',
  dailyFrequencyFilter_isFree: 'การจองแบบไม่คิดค่าบริการ',
  dailyFrequencyMode_RIDE_AND_CARE: 'เดินทางและดูแล',
  dailyFrequencyMode_CARE: 'ดูแล',
  dailyFrequencyMode_RIDE: 'รับส่ง',
  dailyFrequencyMode_TRAVEL: 'เดินทาง',
  dailyFrequencyColumn_provider_id: 'รหัสผู้ให้บริการ',
  dailyFrequencyColumn_provider_name: 'ชื่อผู้ให้บริการ (ปัจจุบัน)',
  dailyFrequencyColumn_business_date: 'วันบริการ (เวลาไทย)',
  dailyFrequencyColumn_date_basis: 'หลักวันที่',
  dailyFrequencyColumn_scheduled_date_trip_count: 'งานที่ใช้เวลาเริ่มตามแผน',
  dailyFrequencyColumn_created_date_fallback_trip_count: 'งานที่ใช้เวลาสร้างแทน',
  dailyFrequencyColumn_requests_count: 'งานในวันบริการ',
  dailyFrequencyColumn_accepted_trip_count: 'งานที่มีหลักฐานการรับงาน',
  dailyFrequencyColumn_completed_trip_count: 'งานที่มีหลักฐานจบงาน',
  dailyFrequencyColumn_cancelled_trip_count: 'งานสถานะยกเลิกปัจจุบัน',
  dailyFrequencyColumn_missed_trip_count: 'งานสถานะพลาดปัจจุบัน',
  dailyFrequencyColumn_cancelled_by_passenger_count: 'ยกเลิกโดยผู้ใช้บริการ',
  dailyFrequencyColumn_cancelled_by_agent_count: 'ยกเลิกโดยพนักงาน',
  dailyFrequencyColumn_cancelled_by_org_user_count: 'ยกเลิกโดยผู้ใช้ในองค์กร',
  dailyFrequencyColumn_cancelled_by_system_count: 'ยกเลิกโดยระบบ',
  dailyFrequencyColumn_cancelled_by_other_count: 'ยกเลิกโดยผู้กระทำประเภทอื่น (พาร์ตเนอร์)',
  dailyFrequencyColumn_cancelled_by_unknown_count: 'ยกเลิกโดยไม่ทราบผู้กระทำ',
  dailyFrequencyColumn_offers_count: 'ข้อเสนองานที่ผูกกับงานในวันบริการ',
  dailyFrequencyColumn_accepted_offer_count: 'ข้อเสนอที่รับ',
  dailyFrequencyColumn_rejected_offer_count: 'ข้อเสนอที่ปฏิเสธ',
  dailyFrequencyColumn_expired_offer_count: 'ข้อเสนอที่หมดอายุ',
  dailyFrequencyColumn_superseded_offer_count: 'ข้อเสนอที่ถูกแทนที่',
  dailyFrequencyColumn_cancelled_offer_count: 'ข้อเสนอที่ยกเลิก',
  dailyFrequencyColumn_pending_offer_count: 'ข้อเสนอที่รอตอบ',
  dailyFrequencyColumn_currency: 'สกุลเงิน',
  dailyFrequencyColumn_fare_total_sum: 'ค่าโดยสารที่บันทึกไว้รวม (บาท)',
  dailyFrequencyColumn_billed_total_sum: 'ยอดเรียกเก็บรวม (บาท)',
  dailyFrequencyColumn_received_total_sum: 'ยอดรับเงินที่บันทึกไว้ (บาท)',
  dailyFrequencyColumn_outstanding_total_sum: 'ยอดค้างชำระรวม (บาท)',
  dailyFrequencyColumn_free_trip_count: 'งานที่มีสถานะการชำระ FREE',
  dailyFrequencyColumn_finance_review_count: 'งานที่ต้องตรวจสอบการเงิน',
  dailyFrequencyColumn_missing_fare_count: 'งานที่ไม่มียอดค่าโดยสารบันทึกไว้',
  dailyFrequencySummary_totalRows: 'แถวผู้ให้บริการ-วันบริการ',
  dailyFrequencySummary_tripCount: 'งานที่ไม่ซ้ำในช่วงวันบริการ',
  dailyFrequencySummary_scheduledDateTripCount: 'งานที่ใช้เวลาเริ่มตามแผน',
  dailyFrequencySummary_createdDateFallbackTripCount: 'งานที่ใช้เวลาสร้างแทน',
  dailyFrequencySummary_acceptedTripCount: 'งานที่มีหลักฐานการรับงาน',
  dailyFrequencySummary_completedTripCount: 'งานที่มีหลักฐานจบงาน',
  dailyFrequencySummary_cancelledTripCount: 'งานสถานะยกเลิกปัจจุบัน',
  dailyFrequencySummary_missedTripCount: 'งานสถานะพลาดปัจจุบัน',
  dailyFrequencySummary_cancelledByPassengerCount: 'ยกเลิกโดยผู้ใช้บริการ',
  dailyFrequencySummary_cancelledByAgentCount: 'ยกเลิกโดยพนักงาน',
  dailyFrequencySummary_cancelledByOrgUserCount: 'ยกเลิกโดยผู้ใช้ในองค์กร',
  dailyFrequencySummary_cancelledBySystemCount: 'ยกเลิกโดยระบบ',
  dailyFrequencySummary_cancelledByOtherCount: 'ยกเลิกโดยผู้กระทำประเภทอื่น (พาร์ตเนอร์)',
  dailyFrequencySummary_cancelledByUnknownCount: 'ยกเลิกโดยไม่ทราบผู้กระทำ',
  dailyFrequencySummary_offersCount: 'ข้อเสนองานที่ผูกกับงานในวันบริการ',
  dailyFrequencySummary_acceptedOfferCount: 'ข้อเสนอที่รับ',
  dailyFrequencySummary_rejectedOfferCount: 'ข้อเสนอที่ปฏิเสธ',
  dailyFrequencySummary_expiredOfferCount: 'ข้อเสนอที่หมดอายุ',
  dailyFrequencySummary_supersededOfferCount: 'ข้อเสนอที่ถูกแทนที่',
  dailyFrequencySummary_cancelledOfferCount: 'ข้อเสนอที่ยกเลิก',
  dailyFrequencySummary_pendingOfferCount: 'ข้อเสนอที่รอตอบ',
  dailyFrequencySummary_fareTotalSum: 'ค่าโดยสารที่บันทึกไว้รวม (บาท)',
  dailyFrequencySummary_billedTotalSum: 'ยอดเรียกเก็บรวม (บาท)',
  dailyFrequencySummary_receivedTotalSum: 'ยอดรับเงินที่บันทึกไว้ (บาท)',
  dailyFrequencySummary_outstandingTotalSum: 'ยอดค้างชำระรวม (บาท)',
  dailyFrequencySummary_freeTripCount: 'งานที่มีสถานะการชำระ FREE',
  dailyFrequencySummary_financeReviewCount: 'งานที่ต้องตรวจสอบการเงิน',
  dailyFrequencySummary_missingFareCount: 'งานที่ไม่มียอดค่าโดยสารบันทึกไว้',
  dailyFrequencySummary_withoutAcceptanceEvidenceTripCount: 'งานที่ไม่มีหลักฐานรับงาน (รวมงานที่ยังไม่มอบหมาย)',
  dailyFrequencySummary_completedStateWithoutEventTripCount: 'งานสถานะจบที่ไม่มีเหตุการณ์จบงาน',
  dailyFrequencySummary_cancelledStateWithoutEventTripCount: 'งานสถานะยกเลิกที่ไม่มีเหตุการณ์ยกเลิก',
  dailyFrequencySource_provider: 'ข้อมูลผู้ให้บริการปัจจุบัน รหัสผู้ให้บริการเป็นส่วนหนึ่งของคีย์แต่ละแถวเสมอ',
  dailyFrequencySource_serviceDate:
    'ใช้ scheduledStart ของ Trip ถ้าไม่มีใช้ createdAt จัดกลุ่มตามวันปฏิทิน Asia/Bangkok ช่วงเวลาเป็น [from, to) ไม่สร้างแถวในวันที่ไม่มีงาน',
  dailyFrequencySource_scheduled: 'จำนวน Trip ไม่ซ้ำในกลุ่มงานที่มี scheduledStart บันทึกไว้',
  dailyFrequencySource_fallback: 'จำนวน Trip ไม่ซ้ำที่ไม่มี scheduledStart วันบริการจึงใช้ createdAt ของ Trip',
  dailyFrequencySource_cohort:
    'Trip ไม่ซ้ำในกลุ่มวันบริการหลังกรองผู้ให้บริการ พื้นที่/กลุ่มบริการปัจจุบัน รูปแบบบริการ และการจองฟรี การจองที่มีสอง Trip นับสองงาน',
  dailyFrequencySource_accepted:
    'Trip ไม่ซ้ำที่มีข้อเสนอสถานะ ACCEPTED หรือเหตุการณ์ TRIP ASSIGNED/REASSIGNED ที่บันทึกไว้ ไม่ถือสถานะปัจจุบันของ Trip เป็นหลักฐานรับงาน',
  dailyFrequencySource_completed:
    'Trip ไม่ซ้ำที่มีเหตุการณ์ TRIP COMPLETED ไม่ขึ้นกับวันเกิดเหตุการณ์ สถานะจบปัจจุบันอย่างเดียวไม่นับเป็นหลักฐานจบงาน',
  dailyFrequencySource_terminal:
    'สถานะ CANCELLED/MISSED ปัจจุบันของ Trip ณ snapshot แบบ repeatable-read อาจซ้อนกับหลักฐานรับงาน/จบงาน',
  dailyFrequencySource_cancellation:
    'เหตุการณ์ TRIP CANCELLED ล่าสุดตามเวลาแล้วรหัสเหตุการณ์ของงานสถานะยกเลิก ไม่เดาจากผู้สร้างการจองหรือผู้รับงานปัจจุบัน',
  dailyFrequencySource_cancellationOther:
    'เหตุการณ์ยกเลิกล่าสุดระบุผู้กระทำประเภท PARTNER ที่ระบบรองรับ ประเภทที่ไม่รองรับนับเป็นไม่ทราบ ไม่ใช่ผู้ใช้ในองค์กร',
  dailyFrequencySource_cancellationUnknown:
    'เหตุการณ์ล่าสุดไม่มีผู้กระทำ ระบุประเภทที่ระบบไม่รองรับ หรือไม่มีเหตุการณ์ยกเลิก ผลรวมทุกกลุ่มผู้กระทำเท่ากับจำนวนงานยกเลิก',
  dailyFrequencySource_offers:
    'รหัสข้อเสนอไม่ซ้ำที่ผูกกับ Trip ในกลุ่มวันบริการ แยกตามสถานะข้อเสนอปัจจุบัน ใช้วันบริการ ไม่ใช้ offeredAt หรือจำนวนครั้งส่งแจ้งเตือน',
  dailyFrequencySource_finance:
    'ข้อมูลการเงินลูกค้า BASE/OVERAGE แบบมาตรฐานหนึ่งแถวต่อ Trip งานยกเลิก/พลาดมียอดเรียกเก็บและค้างเป็นศูนย์ ข้อเสนอ พื้นที่ และบันทึกตรวจสอบไม่เพิ่มยอด ไม่คำนวณราคาหรือปัดเศษใหม่',
  dailyFrequencySource_fare:
    'รวม fare.total ที่ไม่เป็น null ตามข้อมูลการเงิน Trip มาตรฐาน ยอดที่หายไม่นำมารวมและนับแยก ไม่สร้างราคาเต็มย้อนหลัง',
  dailyFrequencySource_receipts:
    'ยอด amountReceived ที่บันทึกในรายการชำระมาตรฐาน รวมงานสิ้นสุดและรายการคืนเงินเต็มจำนวน ไม่ใช่เงินสดสุทธิหลังคืนเงิน',
  dailyFrequencySource_free:
    'นับ payment_state=FREE ตามมาตรฐาน ไม่ใช่ทุกการจองที่ isFree=true งานไม่มีค่าโดยสารแต่มีรายการชำระอาจต้องตรวจสอบแทน',
  dailyFrequencySource_review:
    'requiresFinanceReview ตามมาตรฐาน รวมไม่มีค่าโดยสารแต่มีรายการชำระ และงานสิ้นสุดที่รับเงินแต่ยังไม่คืน รายการคืนเต็มจำนวนที่มีค่าโดยสารไม่ทำให้ตรวจสอบซ้ำ',
  dailyFrequencySource_missingFare: 'จำนวน Trip ในกลุ่มงานที่ไม่มียอดค่าโดยสารปัจจุบันจากข้อมูลที่บันทึกไว้ตามมาตรฐาน',
  dailyFrequencyMeaning_serviceDate: 'ทุกตัวชี้วัดอยู่ในกลุ่มวันบริการ แม้เหตุการณ์มอบหมาย จบงาน หรือข้อเสนองานจะเกิดคนละวัน',
  dailyFrequencyMeaning_scheduled: 'จำนวนงานที่ใช้วันตามแผนและจำนวนที่ใช้เวลาสร้างแทนแบ่งกลุ่ม Trip วันบริการครบทุกงาน',
  dailyFrequencyMeaning_fallback: 'ใช้เวลาสร้างเฉพาะเมื่อไม่มี scheduledStart ไม่ใช่ตัวชี้วัดคำขอจองตามวันเกิดเหตุการณ์',
  dailyFrequencyMeaning_cohort:
    'นับ Trip บริการ ไม่ใช่การจอง ผู้ใช้บริการ หรือครั้งพยายามจัดงาน พื้นที่ปัจจุบันใช้กรองเท่านั้น ไม่เพิ่มจำนวนแถว',
  dailyFrequencyMeaning_accepted: 'หลักฐานการรับงานที่บันทึกไว้ ไม่ใช่กลุ่มสถานะปัจจุบัน งานรับแล้วยกเลิกนับได้ทั้งสองช่อง',
  dailyFrequencyMeaning_completed: 'หลักฐานจบงานที่บันทึกไว้ ไม่เดาจากสถานะปัจจุบัน จำนวนงานที่ขาดเหตุการณ์จะแสดงแยก',
  dailyFrequencyMeaning_terminal: 'สถานะสิ้นสุดปัจจุบัน ณ dataAsOf ไม่ใช่จำนวนเหตุการณ์สิ้นสุดที่เกิดในวันบริการนี้',
  dailyFrequencyMeaning_cancellation: 'งานที่ยกเลิกปัจจุบันแต่ละงานอยู่ในกลุ่มผู้กระทำเพียงหนึ่งกลุ่มตามเหตุการณ์ยกเลิกล่าสุด',
  dailyFrequencyMeaning_cancellationOther:
    'ประเภทอื่นหมายถึง PARTNER ที่ระบบรองรับ ไม่ใช่การเดาว่าเป็นผู้ใช้ในองค์กรหรือประเภทผู้กระทำที่ไม่รู้จัก',
  dailyFrequencyMeaning_cancellationUnknown:
    'ไม่ทราบหมายถึงไม่มีหลักฐานหรือประเภทผู้กระทำที่ไม่รองรับ ไม่โยกไปเป็นผู้ใช้ในองค์กร',
  dailyFrequencyMeaning_offers:
    'นับรหัสข้อเสนอในกลุ่ม Trip เดียวกัน ข้อเสนอที่รับและงานที่มีหลักฐานรับงานเป็นคนละประชากร ไม่ได้แสดงอัตราส่วน',
  dailyFrequencyMeaning_finance:
    'ยอดเรียกเก็บและหนี้ลูกค้า ไม่ใช่ค่าตอบแทนพนักงาน ยอดเรียกเก็บ/หนี้งานสิ้นสุดเป็นศูนย์ ไม่คิดราคาใหม่หรือปัดเศษใหม่',
  dailyFrequencyMeaning_fare: 'ค่าโดยสารปัจจุบันที่บันทึกไว้เท่านั้น ไม่แทนยอดที่หายด้วยราคาเต็มที่สร้างย้อนหลัง',
  dailyFrequencyMeaning_receipts: 'รวมยอดรับเงินที่บันทึกไว้แม้คืนเงินหรือสิ้นสุดงานแล้ว ไม่ใช่เงินสดสุทธิ',
  dailyFrequencyMeaning_free: 'สถานะการชำระ FREE ตามมาตรฐานต่างจากตัวกรองการจองฟรี',
  dailyFrequencyMeaning_review: 'สถานะเพื่อกระทบยอดการเงิน ไม่ใช่ข้อสรุปว่างานสิ้นสุดหรือคืนเงินทุกงานยังไม่ชำระ',
  dailyFrequencyMeaning_missingFare:
    'จำนวนที่ไม่มียอดค่าโดยสารปัจจุบันอธิบายความไม่ครบของยอดรวม ไม่ใช่จำนวนงานค่าโดยสารศูนย์',
  dailyFrequencyEmpty_zero: '0 หมายถึงไม่พบจำนวนหรือยอดรวมที่ตรงในกลุ่มงานหลังกรอง ไม่ใช่ประวัติที่ไม่ทราบ',
  dailyFrequencyEmpty_present: 'มีค่าเสมอในแต่ละแถวผู้ให้บริการ-วันบริการที่มีงาน',
  dailyFrequencyEmpty_missingFare: '0 อาจหมายถึงไม่มียอดหรือมีแต่ค่าโดยสารที่หาย ต้องอ่านคู่กับจำนวนงานไม่มีค่าโดยสาร',
};

export const dailyServiceFrequencyTranslations = { th, en };
